import { render, staticRenderFns } from "./apTrait.vue?vue&type=template&id=0d905467&scoped=true&"
import script from "./apTrait.vue?vue&type=script&lang=js&"
export * from "./apTrait.vue?vue&type=script&lang=js&"
import style0 from "./apTrait.vue?vue&type=style&index=0&id=0d905467&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d905467",
  null
  
)

export default component.exports